import React from 'react';
import { ButtonBox } from "../../ShiftDetailPage/ShiftDetail.styles";
import styles from "../../ShiftDetailPage/ShiftDetail.module.scss";
import { MapButton } from "../../ShiftDetailPage/components";
import { StyledButton } from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import clsx from "clsx";
import { ActionButtonsProps } from './index';

export const ActionButtons = React.memo(({ job, goChat, handleDocumentView }: ActionButtonsProps) => {
    const hasDocument = !!job?.location?.photoUrl;
    
    return (
        <div className={clsx(styles.titleContainer, {
            [styles.hasDocument]: hasDocument
        })}>
            <div className={styles.leftContainer}>
                <ButtonBox className={styles.buttonBox}>
                    <MapButton 
                        className={clsx(styles.actionButton, styles.mapBtn, 'no-fastclick')} 
                        job={job} 
                    />
                    <StyledButton
                        className={clsx(styles.actionButton, styles.chatBtn, 'no-fastclick')}
                        variant="outlined"
                        startIcon={<ChatOutlinedIcon />}
                        color="primary"
                        size="large"
                        id="continue-button"
                        onClick={goChat}>
                        Messages
                    </StyledButton>
                    {hasDocument && (
                        <StyledButton
                            className={clsx(styles.actionButton, styles.docBtn, 'no-fastclick')}
                            variant="outlined"
                            startIcon={<DescriptionOutlinedIcon />}
                            color="primary"
                            size="large"
                            onClick={handleDocumentView}>
                            View Office Document
                        </StyledButton>
                    )}
                </ButtonBox>
            </div>
        </div>
    );
}); 